import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges multiple class names, handling Tailwind class conflicts and conditional class application.
 *
 * Combines class names using `clsx` for conditional class rendering and `twMerge` to handle Tailwind's conflicting classes.
 *
 * @param {...any} inputs - A list of class names, arrays, or objects to be conditionally combined.
 * @returns {string} The final merged string of class names.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
